import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { RouterLink } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { ThemeService } from 'src/app/shared/services/theme.service'; // Importe o serviço
import { Observable } from 'rxjs'; // Importe o Observable

@Component({
  selector: 'app-auth-layout',
  standalone: true,
  imports: [CommonModule, CarouselModule, RouterLink, SharedModule],
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss'],
})
export class AuthLayoutComponent implements OnInit {
  @Input() pageTitle: string = '';
  @Input() subtitle: string = '';
  @Input() actionLinkText: string = '';
  @Input() actionLinkRoute: string = '';

  // Variável reativa para a logo
  logoUrl$: Observable<string>;

  features = [
    {
      title: 'Integrated Analytics Hub',
      image:
        'https://fqjltiegiezfetthbags.supabase.co/storage/v1/render/image/public/block.images/blocks/feature/tab-1.jpg',
      text: 'Unlock powerful insights across your platforms using real-time data to supercharge performance.',
    },
    {
      title: 'Data Security',
      image:
        'https://fqjltiegiezfetthbags.supabase.co/storage/v1/render/image/public/block.images/blocks/feature/tab-2.jpg',
      text: 'Protect your valuable data with enterprise-grade security features ensuring safety and compliance.',
    },
    {
      title: 'Cloud Backups',
      image:
        'https://fqjltiegiezfetthbags.supabase.co/storage/v1/render/image/public/block.images/blocks/feature/tab-3.jpg',
      text: 'Never lose important data with automatic cloud backups that securely store your information.',
    },
  ];

  constructor(private themeService: ThemeService) {
    this.logoUrl$ = this.themeService.logoUrl$;
  }

  ngOnInit(): void {}
}
